import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const IntroReveal = () => {
  const [show, setShow] = useState(() => {
    try {
      if (window.matchMedia("(hover: none), (pointer: coarse)").matches) return false;
      return !sessionStorage.getItem("kronos-intro-seen");
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => {
      try {
        sessionStorage.setItem("kronos-intro-seen", "1");
      } catch {}
      setShow(false);
    }, 1700);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-overlay"
          onClick={() => {
            try {
              sessionStorage.setItem("kronos-intro-seen", "1");
            } catch {}
            setShow(false);
          }}
          className="fixed inset-0 z-[100] flex cursor-pointer items-center justify-center bg-[#0B0C0E]"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex flex-col items-center">
            <motion.img
              src="/kronos-mark-light.webp"
              alt="Kronos"
              data-testid="intro-logo"
              initial={{ opacity: 0, y: 32, scale: 0.94 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="h-24 w-auto sm:h-28"
            />
            <motion.span
              className="mt-8 block h-px bg-[#2563EB]"
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: 120, opacity: 1 }}
              transition={{ duration: 0.9, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
            />
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.7, delay: 0.7 }}
              className="mt-5 font-mono text-[10px] uppercase tracking-[0.5em] text-[#5A5E6B]"
            >
              Kronos
            </motion.p>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.7, delay: 1.1 }}
              className="mt-10 font-mono text-[9px] uppercase tracking-[0.3em] text-[#3A3E48]"
            >
              Tap anywhere to continue
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
